import { render, staticRenderFns } from "./save-user-dialog.component.vue?vue&type=template&id=70db2b28"
import script from "./save-user-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-user-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports